// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.petitionPage {
  background:
    radial-gradient(circle at top left, rgba(39, 118, 233, 0.12), transparent 30%),
    radial-gradient(circle at top right, rgba(12, 52, 103, 0.08), transparent 26%),
    #f6f9ff;
  color: #142033;
}

.petitionHero,
.petitionSection {
  padding: 48px 20px;
}

.petitionHeroInner,
.petitionSectionInner {
  width: min(1180px, 100%);
  margin: 0 auto;
}

.petitionHeroInner {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.9fr);
  gap: 28px;
  align-items: stretch;
}

.petitionHeroCopy,
.petitionHeroPanel,
.petitionCard,
.petitionPrincipleCard,
.petitionDraftCard,
.petitionNoticeCard,
.petitionForm {
  border: 1px solid rgba(113, 152, 214, 0.22);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 18px 60px rgba(31, 67, 123, 0.08);
}

.petitionHeroCopy {
  padding: 34px;
}

.petitionHeroPanel {
  padding: 28px;
  background: linear-gradient(180deg, #eff5ff 0%, #ffffff 100%);
}

.petitionEyebrow,
.petitionSectionLabel {
  display: inline-flex;
  align-items: center;
  padding: 7px 14px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #2a61bf;
  background: rgba(42, 97, 191, 0.08);
}

.petitionHeroTitle,
.petitionSectionTitle {
  margin: 18px 0 0;
  color: #142033;
  line-height: 1.05;
  letter-spacing: -0.04em;
}

.petitionHeroTitle {
  max-width: 11.5ch;
  font-size: clamp(2.35rem, 5.2vw, 4.9rem);
}

.petitionHeroSubheadline {
  margin: 18px 0 0;
  font-size: clamp(1.06rem, 1.8vw, 1.34rem);
  line-height: 1.65;
  color: #304258;
}

.petitionHeroBody,
.petitionSectionIntro,
.petitionFormNote,
.petitionMicrocopy,
.petitionStatusMessage,
.petitionCallout,
.petitionDraftCard p,
.petitionCard p,
.petitionPrincipleCard p {
  color: #506175;
  line-height: 1.7;
}

.petitionHeroBody {
  margin: 16px 0 0;
  font-size: 1rem;
}

.petitionHeroActions,
.petitionActionStack,
.petitionFormActions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.petitionHeroActions {
  margin-top: 24px;
}

.petitionButton {
  appearance: none;
  border: 0;
  border-radius: 16px;
  background: linear-gradient(180deg, #3c86f2 0%, #2d73dd 100%);
  color: #ffffff;
  font-size: 1rem;
  font-weight: 800;
  padding: 14px 20px;
  min-height: 48px;
  cursor: pointer;
  box-shadow: 0 12px 30px rgba(45, 115, 221, 0.22);
}

.petitionButton:hover {
  transform: translateY(-1px);
}

.petitionButton--secondary {
  background: #ffffff;
  color: #21498f;
  border: 1px solid rgba(42, 97, 191, 0.22);
  box-shadow: none;
}

.petitionButton--ghost {
  background: rgba(42, 97, 191, 0.08);
  color: #21498f;
  box-shadow: none;
}

.petitionMicrocopy {
  margin: 18px 0 0;
  font-size: 0.92rem;
  font-style: italic;
}

.petitionHeroPanelHeader {
  font-size: 1.08rem;
  font-weight: 800;
  color: #142033;
}

.petitionSummaryList,
.petitionRules {
  margin: 18px 0 0;
  padding-left: 22px;
}

.petitionSummaryList li,
.petitionRules li {
  margin-top: 12px;
  color: #314155;
  line-height: 1.7;
}

.petitionCallout {
  margin-top: 22px;
  padding: 18px 20px;
  border-radius: 20px;
  background: linear-gradient(180deg, rgba(42, 97, 191, 0.08), rgba(42, 97, 191, 0.02));
}

.petitionNoticeSection {
  padding: 0 20px 24px;
}

.petitionNoticeCard {
  width: min(1180px, 100%);
  margin: 0 auto;
  padding: 18px 22px;
  background: #fffaf6;
  border-color: rgba(217, 122, 55, 0.18);
}

.petitionNoticeCard p {
  margin: 0;
}

.petitionSlogan {
  margin: 0;
  text-align: center;
  font-size: clamp(1.1rem, 2vw, 1.55rem);
  font-weight: 900;
  letter-spacing: -0.03em;
  color: #17346b;
}

.petitionSection--alt {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.45), rgba(230, 239, 255, 0.45));
}

.petitionSectionHeadingBlock {
  max-width: 70ch;
  margin-bottom: 24px;
}

.petitionSectionTitle {
  font-size: clamp(1.8rem, 3.1vw, 2.8rem);
}

.petitionSectionIntro {
  margin: 12px 0 0;
  font-size: 1.03rem;
}

.petitionProblemGrid,
.petitionPrinciplesGrid,
.petitionCtaGrid {
  display: grid;
  gap: 18px;
}

.petitionProblemGrid,
.petitionPrinciplesGrid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.petitionCard,
.petitionPrincipleCard,
.petitionDraftCard {
  padding: 24px;
}

.petitionCard h3,
.petitionPrincipleCard h3 {
  margin: 0;
  color: #142033;
  font-size: 1.08rem;
}

.petitionPrincipleNumber {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #2d73dd;
  color: #ffffff;
  font-weight: 900;
  margin-bottom: 16px;
}

.petitionDraftCard {
  max-width: 920px;
}

.petitionCtaGrid {
  grid-template-columns: minmax(0, 1.2fr) auto;
  align-items: center;
}

.petitionInlineStatus,
.petitionStatusMessage {
  margin: 14px 0 0;
  color: #1f7a40;
  font-weight: 700;
}

.petitionForm {
  padding: 24px;
}

.petitionFieldGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.petitionField {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.petitionField--fullWidth {
  margin-top: 16px;
}

.petitionLabel {
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #304258;
}

.petitionInput,
.petitionTextarea {
  width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid rgba(113, 152, 214, 0.34);
  background: #ffffff;
  padding: 14px 16px;
  font: inherit;
  color: #142033;
}

.petitionTextarea {
  resize: vertical;
  min-height: 136px;
}

.petitionFormActions {
  margin-top: 18px;
  align-items: flex-start;
}

.petitionFormNote {
  margin: 0;
  max-width: 60ch;
  font-size: 0.92rem;
}

.petitionPage script {
  display: none;
}

@media (max-width: 980px) {
  .petitionHeroInner,
  .petitionProblemGrid,
  .petitionPrinciplesGrid,
  .petitionCtaGrid,
  .petitionFieldGrid {
    grid-template-columns: 1fr;
  }

  .petitionHeroTitle {
    max-width: none;
  }
}

@media (max-width: 700px) {
  .petitionHero,
  .petitionSection {
    padding: 30px 16px;
  }

  .petitionHeroCopy,
  .petitionHeroPanel,
  .petitionCard,
  .petitionPrincipleCard,
  .petitionDraftCard,
  .petitionForm {
    padding: 20px;
    border-radius: 22px;
  }

  .petitionHeroActions,
  .petitionActionStack,
  .petitionFormActions {
    flex-direction: column;
    align-items: stretch;
  }

  .petitionButton {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/CaliforniaHiddenTaxFeeTransparencyPetition.css"],"names":[],"mappings":"AAAA;EACE;;;WAGS;EACT,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,SAAS;EACT,oBAAoB;AACtB;;AAEA;;;;;;;EAOE,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6DAA6D;AAC/D;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;;;;EASE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qFAAqF;AACvF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,kBAAkB;EACpB;;EAEA;;;;;;IAME,aAAa;IACb,mBAAmB;EACrB;;EAEA;;;IAGE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".petitionPage {\n  background:\n    radial-gradient(circle at top left, rgba(39, 118, 233, 0.12), transparent 30%),\n    radial-gradient(circle at top right, rgba(12, 52, 103, 0.08), transparent 26%),\n    #f6f9ff;\n  color: #142033;\n}\n\n.petitionHero,\n.petitionSection {\n  padding: 48px 20px;\n}\n\n.petitionHeroInner,\n.petitionSectionInner {\n  width: min(1180px, 100%);\n  margin: 0 auto;\n}\n\n.petitionHeroInner {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.9fr);\n  gap: 28px;\n  align-items: stretch;\n}\n\n.petitionHeroCopy,\n.petitionHeroPanel,\n.petitionCard,\n.petitionPrincipleCard,\n.petitionDraftCard,\n.petitionNoticeCard,\n.petitionForm {\n  border: 1px solid rgba(113, 152, 214, 0.22);\n  border-radius: 28px;\n  background: rgba(255, 255, 255, 0.92);\n  box-shadow: 0 18px 60px rgba(31, 67, 123, 0.08);\n}\n\n.petitionHeroCopy {\n  padding: 34px;\n}\n\n.petitionHeroPanel {\n  padding: 28px;\n  background: linear-gradient(180deg, #eff5ff 0%, #ffffff 100%);\n}\n\n.petitionEyebrow,\n.petitionSectionLabel {\n  display: inline-flex;\n  align-items: center;\n  padding: 7px 14px;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #2a61bf;\n  background: rgba(42, 97, 191, 0.08);\n}\n\n.petitionHeroTitle,\n.petitionSectionTitle {\n  margin: 18px 0 0;\n  color: #142033;\n  line-height: 1.05;\n  letter-spacing: -0.04em;\n}\n\n.petitionHeroTitle {\n  max-width: 11.5ch;\n  font-size: clamp(2.35rem, 5.2vw, 4.9rem);\n}\n\n.petitionHeroSubheadline {\n  margin: 18px 0 0;\n  font-size: clamp(1.06rem, 1.8vw, 1.34rem);\n  line-height: 1.65;\n  color: #304258;\n}\n\n.petitionHeroBody,\n.petitionSectionIntro,\n.petitionFormNote,\n.petitionMicrocopy,\n.petitionStatusMessage,\n.petitionCallout,\n.petitionDraftCard p,\n.petitionCard p,\n.petitionPrincipleCard p {\n  color: #506175;\n  line-height: 1.7;\n}\n\n.petitionHeroBody {\n  margin: 16px 0 0;\n  font-size: 1rem;\n}\n\n.petitionHeroActions,\n.petitionActionStack,\n.petitionFormActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n}\n\n.petitionHeroActions {\n  margin-top: 24px;\n}\n\n.petitionButton {\n  appearance: none;\n  border: 0;\n  border-radius: 16px;\n  background: linear-gradient(180deg, #3c86f2 0%, #2d73dd 100%);\n  color: #ffffff;\n  font-size: 1rem;\n  font-weight: 800;\n  padding: 14px 20px;\n  min-height: 48px;\n  cursor: pointer;\n  box-shadow: 0 12px 30px rgba(45, 115, 221, 0.22);\n}\n\n.petitionButton:hover {\n  transform: translateY(-1px);\n}\n\n.petitionButton--secondary {\n  background: #ffffff;\n  color: #21498f;\n  border: 1px solid rgba(42, 97, 191, 0.22);\n  box-shadow: none;\n}\n\n.petitionButton--ghost {\n  background: rgba(42, 97, 191, 0.08);\n  color: #21498f;\n  box-shadow: none;\n}\n\n.petitionMicrocopy {\n  margin: 18px 0 0;\n  font-size: 0.92rem;\n  font-style: italic;\n}\n\n.petitionHeroPanelHeader {\n  font-size: 1.08rem;\n  font-weight: 800;\n  color: #142033;\n}\n\n.petitionSummaryList,\n.petitionRules {\n  margin: 18px 0 0;\n  padding-left: 22px;\n}\n\n.petitionSummaryList li,\n.petitionRules li {\n  margin-top: 12px;\n  color: #314155;\n  line-height: 1.7;\n}\n\n.petitionCallout {\n  margin-top: 22px;\n  padding: 18px 20px;\n  border-radius: 20px;\n  background: linear-gradient(180deg, rgba(42, 97, 191, 0.08), rgba(42, 97, 191, 0.02));\n}\n\n.petitionNoticeSection {\n  padding: 0 20px 24px;\n}\n\n.petitionNoticeCard {\n  width: min(1180px, 100%);\n  margin: 0 auto;\n  padding: 18px 22px;\n  background: #fffaf6;\n  border-color: rgba(217, 122, 55, 0.18);\n}\n\n.petitionNoticeCard p {\n  margin: 0;\n}\n\n.petitionSlogan {\n  margin: 0;\n  text-align: center;\n  font-size: clamp(1.1rem, 2vw, 1.55rem);\n  font-weight: 900;\n  letter-spacing: -0.03em;\n  color: #17346b;\n}\n\n.petitionSection--alt {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.45), rgba(230, 239, 255, 0.45));\n}\n\n.petitionSectionHeadingBlock {\n  max-width: 70ch;\n  margin-bottom: 24px;\n}\n\n.petitionSectionTitle {\n  font-size: clamp(1.8rem, 3.1vw, 2.8rem);\n}\n\n.petitionSectionIntro {\n  margin: 12px 0 0;\n  font-size: 1.03rem;\n}\n\n.petitionProblemGrid,\n.petitionPrinciplesGrid,\n.petitionCtaGrid {\n  display: grid;\n  gap: 18px;\n}\n\n.petitionProblemGrid,\n.petitionPrinciplesGrid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.petitionCard,\n.petitionPrincipleCard,\n.petitionDraftCard {\n  padding: 24px;\n}\n\n.petitionCard h3,\n.petitionPrincipleCard h3 {\n  margin: 0;\n  color: #142033;\n  font-size: 1.08rem;\n}\n\n.petitionPrincipleNumber {\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #2d73dd;\n  color: #ffffff;\n  font-weight: 900;\n  margin-bottom: 16px;\n}\n\n.petitionDraftCard {\n  max-width: 920px;\n}\n\n.petitionCtaGrid {\n  grid-template-columns: minmax(0, 1.2fr) auto;\n  align-items: center;\n}\n\n.petitionInlineStatus,\n.petitionStatusMessage {\n  margin: 14px 0 0;\n  color: #1f7a40;\n  font-weight: 700;\n}\n\n.petitionForm {\n  padding: 24px;\n}\n\n.petitionFieldGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.petitionField {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.petitionField--fullWidth {\n  margin-top: 16px;\n}\n\n.petitionLabel {\n  font-size: 0.88rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #304258;\n}\n\n.petitionInput,\n.petitionTextarea {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 16px;\n  border: 1px solid rgba(113, 152, 214, 0.34);\n  background: #ffffff;\n  padding: 14px 16px;\n  font: inherit;\n  color: #142033;\n}\n\n.petitionTextarea {\n  resize: vertical;\n  min-height: 136px;\n}\n\n.petitionFormActions {\n  margin-top: 18px;\n  align-items: flex-start;\n}\n\n.petitionFormNote {\n  margin: 0;\n  max-width: 60ch;\n  font-size: 0.92rem;\n}\n\n.petitionPage script {\n  display: none;\n}\n\n@media (max-width: 980px) {\n  .petitionHeroInner,\n  .petitionProblemGrid,\n  .petitionPrinciplesGrid,\n  .petitionCtaGrid,\n  .petitionFieldGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .petitionHeroTitle {\n    max-width: none;\n  }\n}\n\n@media (max-width: 700px) {\n  .petitionHero,\n  .petitionSection {\n    padding: 30px 16px;\n  }\n\n  .petitionHeroCopy,\n  .petitionHeroPanel,\n  .petitionCard,\n  .petitionPrincipleCard,\n  .petitionDraftCard,\n  .petitionForm {\n    padding: 20px;\n    border-radius: 22px;\n  }\n\n  .petitionHeroActions,\n  .petitionActionStack,\n  .petitionFormActions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .petitionButton {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
